<script>
    import axios from 'axios'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
    import UserApi from "../../../api/UserApi";
    import TemplatesDisabledParentProjectsMessage from "../../../templates/DisabledParentProjectsMessage.vue";

    export default {
        data () {
            return {
                name: 'ChangeClusterOwner',
                loading: false,
                error: null,
                currentReportData: null,
                colleagues: [],
                model: ""
            }
        },
        mounted() {
            this.$emitter.on(Listeners.KS_CHANGE_OWNER_REPORT, eventData => this.onChangeOwner(eventData));
        },
        methods: {
            onChangeOwner(data){
                this.currentReportData = data;
                this.onOpen();
            },

            loadColleague() {
                this.loading = true;
                UserApi
                  .getCorporateColleagues()
                  .then(response => this.colleagues = response)
                  .catch(error => this.alertError(error.message))
                  .finally(() => this.loading = false);
            },

            changeOwner(){
                var self = this;

                self.error = null;
                if(!self.model){
                    self.error = this.$t('lang.corp_users.own_clg_err');
                    return false;
                }

                self.loading = true;
                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {user: this.model}
                })
                    .then(function (response) {

                        self.loading = false;
                        self.onClose();
                        self.$emitter.emit(Listeners.KS_FILTER_REFRESH);

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });

            },
            onClose() {
                this.model = "";
                this.$emitter.emit(this.getListenerCancelId)
            },
            onOpen() {
                this.loadColleague();
                this.$emitter.emit(this.getListenerId);
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/clustering/owner/' + this.currentReportData.uid;
            },
            getListenerId() {
                return Listeners.KS_POPUP_CHANGE_CLUSTER_OWNER_REPORT_OPEN;
            },
            getListenerCancelId() {
                return Listeners.KS_POPUP_CHANGE_CLUSTER_OWNER_REPORT_CLOSE;
            },
            isDisabledAction() {
                return !!(this.currentReportData?.monitoring_id);
            },
        },
        components: {
            TemplatesDisabledParentProjectsMessage,
            AdaptersDialog,
            AdaptersDropdown,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getListenerCancelId"
        :header="$t('lang.corp_users.change_owner')"
        :loading="loading"
        :error-message="error"
        :callback-agree="changeOwner"
        :callback-on-hide="onClose"
        :button-agree-label="$t('lang.main.btn.appoint')"
        :is-disable-send="isDisabledAction"
    >
        <template #content>
            <TemplatesDisabledParentProjectsMessage
                v-if="isDisabledAction"
                :monitoring-id="currentReportData.monitoring_id"
                :monitoring-name="currentReportData.monitoring_name"
            />
            <AdaptersDropdown
                v-else
                v-model="model"
                :options="colleagues"
                optionValue="email"
                optionLabel="email"
                :placeholder="$t('lang.corp_users.select_user')"
                class="w-full"
            />
        </template>
    </AdaptersDialog>
</template>
